<template>
  <div class="error-container">
    <h1 class="error-code">404</h1>
    <p class="error-info">
      Page not found
    </p>
  </div>
</template>

<script>
export default {
  name: 'AppNotFound'
}
</script>

<style scoped>
.error-container {
  padding: 15vh 0 0 0;
  text-align: center;
}

.error-code {
  font-size: 10rem;
}

.error-info {
  font-size: 6rem;
}
</style>
